export class ArchAIProjectRepositoryError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'ArchAIProjectRepositoryError';
    this.details = details;
  }
}

export class ArchAIProjectRepository {
  constructor(options = {}) {
    this.apiBase = String(options.apiBase || '/api').replace(/\/$/, '');
    this.fetchImpl = options.fetchImpl || globalThis.fetch?.bind(globalThis);
    this.credentials = options.credentials || 'same-origin';
  }

  async request(path) {
    if (!this.fetchImpl) throw new ArchAIProjectRepositoryError('当前环境不支持项目数据请求。');
    let response;
    try {
      response = await this.fetchImpl(`${this.apiBase}${path}`, { credentials: this.credentials });
    } catch (cause) {
      throw new ArchAIProjectRepositoryError('无法连接 ArchAI 项目接口。', { path, cause });
    }
    if (!response.ok) {
      throw new ArchAIProjectRepositoryError(`项目接口请求失败（${response.status}）。`, {
        path,
        status: response.status
      });
    }
    return response.json();
  }

  async getProjectSnapshot(projectId) {
    const cleanId = String(projectId || '').trim();
    if (!cleanId) throw new ArchAIProjectRepositoryError('接入主站数据时必须提供 projectId。');
    const id = encodeURIComponent(cleanId);
    const [projectPayload, materialPayload, assetPayload] = await Promise.all([
      this.request(`/projects/${id}`),
      this.request(`/projects/${id}/materials`),
      this.request(`/projects/${id}/assets`)
    ]);
    return {
      version: 1,
      source: { kind: 'archai-api' },
      project: projectPayload.project || projectPayload,
      stages: projectPayload.stages || [],
      materials: materialPayload.materials || materialPayload || [],
      assets: assetPayload.assets || assetPayload || []
    };
  }

  async getSnapshot(projectId) {
    return this.getProjectSnapshot(projectId);
  }
}
